<template>
  <div id="knowledgeBaseStep3Page"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="پایگاه دانش"></ActionBar>
    <div class="knowledge-base-header p-0 d-flex justify-space-between">
      <div class=" white--text font16px mr-6 py-2">{{ title }}</div>
      <!--      <img :src="getImgUrl(src)" class="knowledge-base-shadow p-2 img-fluid ">-->
    </div>
    <div v-if="!hasData" class="row mx-2 mt-10 knowledge-base-body">
      <div class="col-12">
        <v-alert
            border="bottom"
            class="mt-4 text-center"
            color="primary"
            dark>
          دسته بندی وجود ندارد
        </v-alert>
      </div>
    </div>
    <div v-else class="row container mx-auto p-0  mt-2 knowledge-base-body">
      <div v-for="item in items" :key="item.KnowledgeID" class="col-12 col-sm-6 col-lg-4">
        <div class="card-shadow round10px bg-white p-2 my-2 cursor-pointer"
             @click="goToKnowledgeBaseStep4(item.PackageIDs,item.packagesName,item.KnowledgeID)">
          <div class="card-min-height-knowledge">
            <v-img v-if="item.FileUrl !== null" :src="$replaceHttps(item.FileUrl)" class="round10px"
                   height="280"></v-img>
          </div>
          <div class="mt-3">{{ item.Name }}</div>
          <div class="grey--text font12px mt-3">{{ $convertDate(item.ModifiedDate) }}</div>
        </div>
      </div>
    </div>
    <FooterMenu :currentPage="'knowledgeBase'"/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>


    <v-dialog
        v-model="showBuyPackageDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ buyDialogText }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="forth" rounded @click="showBuyPackageDialog = !showBuyPackageDialog">
            <span class="white--text">بستن</span>
          </v-btn>
          <v-btn class="px-8" color="primary" rounded @click="goToBuyMemberShip">
            لیست پکیج ها
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "KnowledgeBaseStep3",
  metaInfo: {
    title: 'مسیربرتر-پایگاه دانش'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    src: null,
    title: null,
    items: [],
    showLoaderDialog: false,
    hasData: true,
    isLoaded: false,
    activePackages: null,
    packages: [],
    showBuyPackageDialog: false,
    buyDialogText: ''
  }),
  mounted() {
    _this = this
    this.title = this.$route.query.title
    this.showLoaderDialog = true
    this.getPackagePayHistoryData()
    this.getPackages()
  },
  methods: {
    getPackagePayHistoryData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let now = this.$convertDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))

      let date = new Date()
      date.setFullYear(date.getFullYear() - 1)
      let yearAgo = this.$convertDate(new Date(date - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))

      let urlencoded = new URLSearchParams();

      urlencoded.append("AppUserID", this.$getUserData().userID);
      urlencoded.append("StartDate", yearAgo);

      urlencoded.append("EndDate", now);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PackageReportManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false
            let json = JSON.parse(result)
            _this.activePackages = json.filter(x => x.IsExpire === false)
          })
          .catch(error => console.log('error', error));
    },
    getPackages() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PackageManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.packages = JSON.parse(result)
            _this.getData()
          })
          .catch(error => console.log('error', error));
    },
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "KnowledgeManagement/ListKnowledge?KnowledgeSubCategoryID=" + _this.$route.query.KnowledgeSubCategoryID + "&KnowledgeCategoryID=" + _this.$route.query.KnowledgeCategoryID, requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false
            let json = (JSON.parse(result))
            let active = json.filter(x => x.IsActive === true)
            if (active.length === 0) {
              _this.hasData = false
            } else {
              let packages = _this.packages

              for (let i = 0; i < active.length; i++) {
                //json[i].packagesName = []
                if (active[i].PackageIDs !== null) {
                  for (let j = 0; j < active[i].PackageIDs.length; j++) {
                    if (active[i].packagesName === undefined) {
                      active[i].packagesName = [];
                    }
                    let find = packages.find(x => x.PackageID === active[i].PackageIDs[j])
                    active[i].packagesName.push(find.Name)
                  }
                }
              }

              _this.items = active
              _this.isLoaded = true
            }
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    goToKnowledgeBaseStep4(packageID, name, id) {
      let activePackages = this.activePackages
      if (packageID !== null) {
        let findPackage = []
        for (let i = 0; i < packageID.length; i++) {
          findPackage.push(activePackages.filter(x => x.PackageID === packageID[i]))
        }
        if (findPackage[0].length <= 0) {
          this.showBuyPackageDialog = true
          if (name.length === 1) {
            this.buyDialogText = 'برای دسترسی به این گزارش باید   پکیج (   ' + name[0] + ') را خریداری کنید'

          } else {
            let text = ''
            for (let i = 0; i < name.length; i++) {
              text += name[i] + '،'
            }
            this.buyDialogText = 'برای دسترسی به این گزارش باید یکی از پکیج های ( ' + text + ') را خریداری کنید'
          }
        } else {
          this.$router.push({path: 'KnowledgeBaseStep4', query: {KnowledgeID: id}})
        }
      } else {
        this.$router.push({path: 'KnowledgeBaseStep4', query: {KnowledgeID: id}})
      }

    },
    goToBuyMemberShip() {
      this.$router.push({path: 'BuyMembership'})
    },
  }
}
</script>

<style scoped>

</style>